const permissions = {
  listEmailNotification: 'NT001',
  addEmailNotification: 'NT004',
  removeEmailNotification: 'NT005',

  listConsoleNotification: 'NT002',
  addConsoleNotification: 'NT006',
  removeConsoleNotification: 'NT008',

  listWebServiceNotification: 'NT003',
  addWebServiceNotification: 'NT007',
  removeWebServiceNotification: 'NT009',

  listSystemNotification: 'NT010',
  addSystemNotification: 'NT011',
  removeSystemNotification: 'NT012',
  editSystemNotification: 'NT013',

  listTrackerNotifications: 'NT015', // Permiso para ver notificaciones de Tracker
  editTrackerNotifications: 'NT017', // Permiso para editar notificaciones de Tracker
  createTrackerNotifications: 'NT016', // Permiso para crear notificaciones de Tracker
  deleteTrackerNotifications: 'NT018' // Permiso para eliminar notificaciones de Tracker

};

export default permissions;
